/**
 * 数值格式化
 */
import { unref } from 'vue'
import { isNumber, isString } from '@element-plus/utils'
import type { Ref } from 'vue'

export const numberalPattern = /^(%?)(,?)(0+|#+)((\.)(0{1,10}|#{1,10}))?(%?)$/

export interface Numberal {
  integer: string
  decimal: string
  numberal: string
}

export const useNumberal = (
  value: number | Ref<number>,
  format: string | Ref<string>
): Numberal => {
  const result: Numberal = {
    integer: '',
    decimal: '',
    numberal: '',
  }

  const unValue = unref(value)
  const unFormat = unref(format)

  if (!isNumber(unValue) || !isString(unFormat)) return result

  const match = unFormat.match(numberalPattern)
  if (match && match[0]) {
    const leftPercent = !!match[1] // * 100
    const rightPercent = !!match[7] // / 100
    const thousand = !!match[2] // 千分位 - 忽略integer
    const integer = match[3] // .length
    const decimal = !!match[4] // .length
    const integerLen = match[3].length
    const decimalLen = decimal ? match[6].length : 0
    const integerPad = !!integer && match[3][0] === '0'
    const decimalPad = !!decimal && match[6][0] === '0'

    let num = unValue
    if (leftPercent) {
      num *= 100.0
    }

    if (rightPercent) {
      num /= 100.0
    }

    const fixedStr = num.toFixed(decimalLen)
    const integerStr = fixedStr.split('.')[0]
    const decimalStr = fixedStr.split('.')[1] || ''

    if (decimalPad) {
      result.decimal = decimalStr.padEnd(decimalLen, '0')
    } else if (decimalStr) {
      const decimalNum = Number.parseFloat(`0.${decimalStr}`)
      if (decimalNum) {
        result.decimal = decimalNum.toString().replace('0.', '')
      } else {
        // 整数
        result.decimal = ''
      }
    } else {
      result.decimal = ''
    }

    if (thousand) {
      result.integer = integerStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    } else {
      result.integer = integerPad
        ? integerStr.padStart(integerLen, '0')
        : Number.parseFloat(integerStr || '0').toString()
    }

    result.numberal = `${result.integer}${
      !!decimalLen && !!result.decimal ? '.' : ''
    }${result.decimal}`
  }

  return result
}
